import React, { useState } from 'react';
import { Tabs, type Tab } from '../../../common/Tabs';
import { UserMemoryComponent } from './UserMemory';
import { TenantMemoryComponent } from './TenantMemory';
import { ProtectedComponent } from '../../../ProtectedComponent/ProtectedComponent';
import { useUserProfile } from '../../../../api/profile';
import { isPermitted } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

const ABOUT_YOU_ID = 'about-you';
const ABOUT_COMPANY_ID = 'about-company';

export const MemoryTab: React.FC = () => {
  const { t } = useTranslation('pleri/chat');
  const [activeTabId, setActiveTabId] = useState(ABOUT_YOU_ID);
  const { data: userProfile } = useUserProfile();
  const permissions = userProfile?.permissions || [];
  const hasCompanyPermission = isPermitted(
    permissions,
    ['pleri:Write', '*'],
    false,
  );

  const tabs: Tab[] = [
    {
      id: ABOUT_YOU_ID,
      label: t('userLevelMemory'),
      content: <UserMemoryComponent />,
      dataTestId: 'memory-tab-user',
    },
    ...(hasCompanyPermission
      ? [
          {
            id: ABOUT_COMPANY_ID,
            label: t('tenantLevelMemory'),
            content: (
              <ProtectedComponent permission={['pleri:Write', '*']}>
                <TenantMemoryComponent />
              </ProtectedComponent>
            ),
            dataTestId: 'memory-tab-tenant',
          },
        ]
      : []),
  ];

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <Tabs
        tabs={tabs}
        activeTabId={activeTabId}
        onTabChange={setActiveTabId}
        className="flex h-full flex-1 flex-col overflow-hidden"
        sticky
      />
    </div>
  );
};

export default MemoryTab;
